import config from "../config/application"
import { apiCall } from "./common/base.service"
import permission from "./permissions.service"
import dictionary from '../config/dictionary';

const save_bank = "/register"
const get_banks = "/getBanks"
const delete_bank = "/delete"
const edit_bank = "/update"

class BankService {
    getBanks() {
        const url = `${config.data.providers.bank.url}${get_banks}`
        return apiCall("get", url)
    }

    async saveBanks(json) {
        const url = `${config.data.providers.bank.url}${save_bank}`
        const validPermission = await bankService.getPermissions(json.createdBy, dictionary.configApp.action.add)
        const error = validPermission?.response?.data?.error
        return error ? validPermission : apiCall("post", url, json)
    }
    async deleteBank(bank) {
        const url = `${config.data.providers.bank.url}${delete_bank}`
        const validPermission = await bankService.getPermissions(bank.auth, dictionary.configApp.action.delete)
        const error = validPermission?.response?.data?.error
        return error ? validPermission : apiCall("delete", url, bank.selectRows)
    }

    async editBank(bank) {
        const url = `${config.data.providers.bank.url}${edit_bank}`
        const validPermission = await bankService.getPermissions(bank.createdBy, dictionary.configApp.action.edit)
        const error = validPermission?.response?.data?.error
        return error ? validPermission : apiCall("put", url, bank)
    }
    getPermissions = (username, action) => {
        return permission.validPermission(
            process.env.REACT_APP_TRANSACTION_BANK,
            username,
            process.env.REACT_APP_SYSTEM_CODE, action);
    }
}
const bankService = new BankService()
export default bankService